// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__164H4","top":"styles_top__1wEJb","left":"styles_left__1bLVj","description":"styles_description__3qMK-"};